export const chessViewMode = {
  stages: 'STAGES',
  acceptanceStatuses: 'ACCEPTANCE_STATUSES',
  applicationMonitoring: 'APPLICATION_MONITORING'
};
